import request from '@/utils/request'

// 查询服务技能列表
export function listSkill(skillType) {
  return request({
    url: '/homeservice/skill/list',
    method: 'get',
    params: { skillType }
  })
}

// 查询服务技能详情
export function getSkill(id) {
  return request({
    url: '/homeservice/skill/detail',
    method: 'get',
    params: { id }
  })
}

// 新增服务技能
export function addSkill(data) {
  return request({
    url: '/homeservice/skill/add',
    method: 'post',
    data: data
  })
}

// 编辑服务技能
export function editSkill(data) {
  return request({
    url: '/homeservice/skill/edit',
    method: 'post',
    data: data
  })
}

// 删除服务技能
export function delSkill(data) {
  return request({
    url: '/homeservice/skill/delete',
    method: 'post',
    data: data
  })
}
